// extracted by mini-css-extract-plugin
module.exports = {"sideNav":"documentSideNav-module--sideNav--q8eJR","active":"documentSideNav-module--active--18Gva"};